// Production only. sw.js's fetch handler treats any extensionless GET as an app-shell
// route (NetworkFirst, falling back to a cached/offline response) — that heuristic also
// catches Vite's dev-only endpoints (/@vite/client, /@react-refresh, unbundled route
// chunks, ...). A transient hiccup on one of those in dev — e.g. right around an HMR
// reload — can make the SW hand back a stale or fake "offline" response in place of a
// live JS module, which breaks module loading with no visible error and leaves the app
// stuck on a blank white screen until the SW is unregistered. There's no such thing as
// "offline production build" to protect during `npm run dev`, so just skip it there.
export function registerServiceWorker(): void {
  if (import.meta.env.DEV) return;
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    });
  }
}
